import React from "react";
import clsx from "clsx";

import "./styles.css";

interface CtaCardProps {
  href?: string;
  alt?: string;
  tint?: string;
  title?: string;

  className?: string;
}

const CtaCard: React.FC<CtaCardProps> = ({
  href = null,
  alt = null,
  tint = "white",
  title = null,

  className,
  ...props
}) => {
  const dynamicClasses = {
    [`s2-cta-card--${tint}`]: tint,
  };

  return (
    <a
      href={href}
      title={title}
      target="_blank"
      className={clsx("s2-cta-card", dynamicClasses, className)}
    >
      {props.children}
    </a>
  );
};

export default CtaCard;
